import { supabase } from '../supabase'

/**
 * Log a health-data access event to access_log.
 * Never throws — logging failures must not break user flows.
 *
 * @param {{ resourceType: string, resourceId?: string, homeId?: string, action: string }} opts
 */
export async function logAccess({ resourceType, resourceId, homeId, action }) {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) return

    await supabase.from('access_log').insert({
      user_id: user.id,
      resource_type: resourceType,
      resource_id: resourceId ?? null,
      home_id: homeId ?? null,
      action,
      user_agent: navigator?.userAgent ?? null,
      ip_address: null, // not available client-side; populated server-side via future edge function if needed
    })
  } catch (err) {
    console.warn('[accessLog] failed to write access log:', err)
  }
}
